import hcAxios, { AxiosResponse } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'

export type AndroidOfcUrl = {
  versionNum: string
  channel: string
  downloadUrl: string
}

export type IosOfcUrl = {
  versionNum: string
  channel: string
  downloadUrl: string
}

export type IGetDownloadUrlServiceResponse = TResponse<{
  macUrl: string
  androidUrl: any[]
  androidOfcUrl: AndroidOfcUrl[]
  iosOfcUrl: IosOfcUrl[]
  iosUrl: any[]
  windowsUrl: string
}>

export const getDownloadUrlService: () => Promise<AxiosResponse<IGetDownloadUrlServiceResponse>> = async () => {
  return await hcAxios.post<IGetDownloadUrlServiceResponse>('/hk-web/v2/common/dowloadUrl') // 本应用GET请求，但是这里写成了POST请求
}
